import PropTypes from "prop-types";
import React, { Component } from "react";
import BrandingSettings from "../../constants/BrandingSettings";

class OrganisationLogo extends Component {
    render() {
        const { classes, logoUrl, onClick, width, height } = this.props;

        return (
            <div
                className={classes.root ? classes.root : ""}
                role={"button"}
                tabIndex={"-1"}
                onClick={onClick ? onClick : null}
            >
                {logoUrl ? (
                    <img alt={"logo"} className={classes.image ? classes.image : ""} src={logoUrl || ""} />
                ) : (
                    <div
                        style={{
                            height,
                            width,
                        }}
                    />
                )}
            </div>
        );
    }
}

export default OrganisationLogo;

OrganisationLogo.propTypes = {
    classes: PropTypes.shape({
        image: PropTypes.string,
        root: PropTypes.string,
    }),
    height: PropTypes.number,
    logoUrl: PropTypes.string,
    onClick: PropTypes.func,
    width: PropTypes.number,
};

OrganisationLogo.defaultProps = {
    classes: {
        image: "",
        root: "",
    },
    height: BrandingSettings.organisationLogo.displayHeight,
    logoUrl: "",
    onClick: null,
    width: BrandingSettings.organisationLogo.displayWidth,
};
